export default {"src":"/fe-dsa/_next/static/media/breadcrumbs_home.d7d85199.svg","height":18,"width":18};